<p-dialog [(visible)]="displayFollowLink1" (onShow)="onShow()"  [breakpoints]="{'1200px': '65vw', '960px': '75vw', '640px': '100vw'}" [style]="{width: '55vw'}" [modal]="true" [resizable]="false">
    <ng-template class="p-dialog-title" pTemplate="header">
      <div>
        <i class="fa fa-pencil me-2" aria-hidden="true"></i>
        <strong>Crear link de seguimiento</strong>
      </div>
    </ng-template>

    <div *ngIf="!tengoLink">

      <div class="dialog-body-container">

        <div class="p-fluid p-formgrid p-grid" style="font-size: 12px;">
          <!-- <div class="dialog-form-container gl-middleline" [ngStyle]="{'display':formDisplay}"> -->
          <div class="dialog-form-container ">
            <div class="row">
              
              <div class="col p-field">
                <label class="row">
                  <div class="col-5 d-flex align-items-center justify-content-start text-start fw-bold">
                    <label for="firstname">Periodo de localizacion:</label>
                  </div>
                  <div class="col-7">
                    <!-- <input #name id="firstname" type="text" value="{{config.name}}"  pInputText class="p-inputtext-sm" placeholder=""> -->
                  </div>
                </label>
              </div>
  
            </div>
  
            <div class="row">
              <div class="col p-field">
                <label class="row">
                  <div class="col-2 d-flex align-items-center justify-content-start text-start fw-bold">
                    <label for="sim">de:</label>
                  </div>
                  <div class="col-5">
                      <p-calendar 
                        [(ngModel)]="vf.fecha_desde" 
                        dateFormat="yy-mm-dd"
                        [appendTo]="'body'"
                        [monthNavigator]="true"
                        [yearNavigator]="true"
                        yearRange="2000:2040"
                        [showIcon]="true"
                        [maxDate]="vf.fecha_hasta"
                      ></p-calendar> 
                  </div>
                  <div class="col-5">
                      <p-calendar 
                        [(ngModel)]="vf.hora_desde"
                        [timeOnly]="true"
                        [appendTo]="'body'"
                        [showIcon]="true"
                        icon="pi pi-clock"
                      ></p-calendar> 
                  </div>
                </label>
              </div>
            </div>
            
            <div class="row">
              <div class="col p-field">
                <label class="row">
                  <div class="col-2 d-flex align-items-center justify-content-start text-start fw-bold">
                    <label for="sim">Hasta:</label>
                  </div>
                  <div class="col-5">
                      <p-calendar 
                        [(ngModel)]="vf.fecha_hasta" 
                        dateFormat="yy-mm-dd"
                        [appendTo]="'body'"
                        [monthNavigator]="true"
                        [yearNavigator]="true"
                        yearRange="2000:2040"
                        [showIcon]="true"
                        [minDate]="vf.fecha_desde"
                      ></p-calendar> 
                  </div>
                  <div class="col-5">
                      <p-calendar 
                        [(ngModel)]="vf.hora_hasta"
                        [timeOnly]="true"
                        [appendTo]="'body'"
                        [showIcon]="true"
                        icon="pi pi-clock"
                      ></p-calendar> 
                  </div>
                </label>
              </div>
            </div>
  
  
  
            <div class="row">
              <div class="col p-field">
                <label class="row">
                  <div class="col-12 d-flex align-items-center justify-content-start text-start fw-bold">
                      <p-checkbox [(ngModel)]="vf.chk_multiples_unidades" [binary]="true" [disabled]="false" label="Elegir múltiples vehículos" ></p-checkbox>
                  </div>
                </label>
              </div>
            </div>

            <div *ngIf="vf.chk_multiples_unidades">
              
                <div class="row">
                  <div class="col p-field">
                    <label class="row ">
                        <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                          <label>Vehículos:</label>
                        </div>
                        <div class="col-9">
      
                          <div class="gl-row-underline">
                            <p-multiSelect [options]="cars" [(ngModel)]="p_vehicles" optionLabel="nombre" [showToggleAll]="true" [appendTo]="'body'" placeholder="Seleccione..." [selectedItemsLabel]="'{0} vehiculos seleccionados'"
                            ></p-multiSelect>
                          </div>
      
                        </div>
                    </label>
                  </div>
                </div>

            </div>
  
  
            <!-- <div class="row">
              <div class="col p-field">
                <label class="row gl-row-underline">
                  <div class="col-5 d-flex align-items-center justify-content-start text-start fw-bold">
                    <label for="empresa">Empresa:</label>
                  </div>
                  <div class="col-7">
                      <p-calendar  [(ngModel)]="date" ></p-calendar>
                  </div>
                </label>
              </div>
              <div class="col p-field">
                <div class="row gl-row-underline">
                  <div class="col-5 d-flex align-items-center justify-content-start text-start fw-bold">
                    <label for="placa">Placa:</label>
                  </div>
                  <div class="col-7">
                  </div>
                </div>
              </div>
            </div> -->
  
            <br>
  
            <div class="row">
              <div class="col p-field">
                <label class="row">
                  <div class="col-12 d-flex align-items-center justify-content-start text-start fw-bold">
                      <p-checkbox [(ngModel)]="vf.chk_historial_ruta" [binary]="true" [disabled]="false" label="Historia de Ruta" ></p-checkbox>
                  </div>
                </label>
              </div>
            </div>
  
            <br>
  
            <div class="row">
              <div class="col p-field">
                <label class="row">
                  <div class="col-12 d-flex align-items-center justify-content-start text-start fw-bold">
                      <p-checkbox [(ngModel)]="vf.chk_historial_evento" [binary]="true" [disabled]="false" label="Historial de Eventos" [disabled]="!vf.chk_historial_ruta"></p-checkbox>
                  </div>
                </label>
              </div>
            </div>
  
  
            <br>
            <div class="row">
              <div class="col p-field">
                <label class="row">
                  <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                    <label for="sim">Notas :</label>
                  </div>
                  <div class="col-9">
                    <input  id="firstname" type="text" [(ngModel)]="vf.nota"  pInputText class="p-inputtext-sm" placeholder="">
                  </div>
                </label>
              </div>
            </div>
  
            <div class="row">
              <div class="col p-field">
                <label class="row">
                  <div class="col-12 d-flex align-items-center justify-content-start text-start fw-bold">
                      <p-checkbox [(ngModel)]="vf.chk_mostrar_nota" [binary]="true" [disabled]="false" label="Mostrar publicamente las notas" ></p-checkbox>
                  </div>
                </label>
              </div>
            </div>
  
  
  
  
          </div>
        </div>
        
      </div>
      <br>

      <p-footer>
        <div>
            <div class="row d-flex justify-content-center">
              <div class="col-6">
                <button (click)="confirm()" type="button" class="btn-gl-cancel btn-dark-hover btn-sm w-100" [disabled]="false">Generar enlace de seguimiento</button>
              </div>
            </div>
        </div>
      </p-footer>
  

    </div>






    <div *ngIf="tengoLink">

      <div style="background-color: rgb(242, 252, 241);border: 1px solid rgb(0, 0, 0);padding: 20px;margin: 2px;font-size: 12px;">
          {{strLink}}
      </div>

      <p-footer>
          <div style="font-size: 10px;">
              El enlace expirará en 24 horas.
          </div>
      </p-footer>

    </div>

</p-dialog>
